import { DateField } from 'admin';
import type { Load } from 'api';
import { Link } from 'react-router-dom';
import { Button, DetailsList, Stack } from 'ui';

import { formatLoadStatus } from '../../utils/formatLoadStatus';
import { LoadStatusChip } from '../LoadStatusChip/LoadStatusChip';

export const LoadDetails = ({
  load,
  onNotNeededClick,
}: {
  load: Load | null;
  onNotNeededClick: (id: number) => void;
}) => {
  const handleInspectionIsNotNeeded = async () => {
    if (load?.id) {
      onNotNeededClick(load.id);
    }
  };

  return (
    <DetailsList
      details={[
        {
          title: 'Status',
          value: (
            <Stack direction="row" justifyContent="space-between">
              <LoadStatusChip status={formatLoadStatus(load?.status)} />
              {load?.status !== 'Not needed' && (
                <Button onClick={handleInspectionIsNotNeeded} variant="secondary" size="small">
                  Not Needed
                </Button>
              )}
            </Stack>
          ),
        },
        {
          title: 'Collection Time',
          value: <DateField value={load?.estimated_collection_time} format="LLL" />,
        },
        {
          title: 'Inspection',
          value: load?.inspection_id ? (
            <Link to={`/ground-control-control-control-control/inspections/${load.inspection_id}/`}>
              Has Inspection
            </Link>
          ) : (
            'No Inspection'
          ),
        },
      ]}
    />
  );
};
